<div class="p-10" *ngIf="selectionService.dataSource.data.length === 0 && !selectionService.isLoading">
    <p>No se encontraron registros</p>
</div>

<div class="p-10" *ngIf="selectionService.dataSource.data.length > 0 && !selectionService.isLoading">
    <div class="inner-card p-b-10 ">
        <div class="table-header-row">

            <mat-paginator [pageIndex]="selectionService.paginationProps.pageIndex"
                [length]="selectionService.paginationProps.length"
                [pageSize]="selectionService.paginationProps.pageSize" [pageSizeOptions]="[10, 50, 100]"
                (page)="getActions($event)">
            </mat-paginator>

            <button mat-icon-button [matMenuTriggerFor]="tableColumnMenu" class="except table-toggle-button">
                <mat-icon class="except">table_chart</mat-icon>
            </button>

            <mat-menu #tableColumnMenu="matMenu" class="except">
                <div class="table-column-toggle-menu" (click)="$event.stopPropagation();">
                    <mat-checkbox *ngFor="let cd of displayedColumns | listFilter: 'ISPERMIT': true; let i = index"
                        (change)="toggleDisplayColumn(cd.column, $event.checked)" [checked]="cd.show"
                        [hidden]="cd.disabled">
                        {{cd.name}}</mat-checkbox>
                </div>
            </mat-menu>

        </div>
        <div class="list-tbl-view scroll-selection">
            <table mat-table [dataSource]="selectionService.dataSource" class="mat-elevation-z8 " #actionSelection
                id="selection-action">
                <caption></caption>

                <ng-container matColumnDef="action" class="except">
                    <th id="actions" mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let action" class="except">

                        <button *ngIf="action.bloq === null" aria-haspopup="true"
                            class="navbar-toggle-button mat-icon-button icn-person except"
                            (click)="selectionService.GoToEmployee(action.trabajadorId, action.bajaId)">
                            <span class="mat-button-wrapper except">
                                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img"
                                    aria-hidden="true">
                                    person </mat-icon>
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round except" matripple=""
                                ng-reflect-centered="true">
                            </div>
                            <div class="mat-button-focus-overlay except"></div>
                        </button>

                        <button
                            *ngIf="action.fAlta === null 
                        && (selectionService.selectionPermissions.HasMarcaView || selectionService.selectionPermissions.HasMarcaExternalView) "
                            mat-icon-button [matMenuTriggerFor]="appMenu" class="except">
                            <mat-icon class="except">more_vert</mat-icon>
                        </button>

                        <mat-menu #appMenu="matMenu" class="except">
                            <h5 class="p-l-10  mb-4 mt-4 font-bold">Marcas</h5>
                            <mat-divider></mat-divider>
                            <div class="table-column-toggle-menu">
                                <mat-checkbox class="no-check"
                                    *ngFor="let marca of marcaOptionList | listFilter: 'ISPERMIT': true; let i = index"
                                    (change)="toggleMarca(action, marca, $event.checked)"
                                    [checked]="action.marcas !== null && action.marcas.includes(marca.label)">
                                    <span [class]="marca.className">{{marca.label}}</span> {{marca.text}}
                                </mat-checkbox>
                            </div>
                            <h5 class="p-l-10  mb-4 mt-4 font-bold">Revisión</h5>
                            <mat-divider></mat-divider>
                            <div class="table-column-toggle-menu revision-menu">
                                <mat-checkbox class="no-check" *ngFor="let revision of RevisionOptionList"
                                    (click)="onClickRevision(revision.value,action)">
                                    {{revision.text}}
                                </mat-checkbox>
                            </div>
                        </mat-menu>

                        <button mat-button *ngIf="recordingService.isMatching" (click)="confirmMatch(action)"><span
                                class="fa fa-link"></span></button>

                    </td>
                </ng-container>

                <ng-container matColumnDef="revision">
                    <th id="revision" mat-header-cell *matHeaderCellDef>Revisión </th>
                    <td mat-cell *matCellDef="let acutation">
                        <mat-checkbox *ngIf="filterService.IsRevisor" [disabled]="acutation.isCheckRevision"
                            [(ngModel)]="acutation.isCheckRevision" (ngModelChange)="updateValu(acutation)">
                        </mat-checkbox>

                        <mat-icon *ngIf="!filterService.IsRevisor && acutation.isCheckRevision"
                            class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                            check </mat-icon>
                    </td>
                </ng-container>



                <ng-container matColumnDef="revisada">
                    <th id="revisada" mat-header-cell *matHeaderCellDef> Revisada </th>
                    <td mat-cell *matCellDef="let acutation">
                        <mat-icon *ngIf="acutation.revisada >= 25 && acutation.revisada <= 30"
                            class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                            check </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="marcas">
                    <th id="marcas" mat-header-cell *matHeaderCellDef> Marcas </th>
                    <td mat-cell *matCellDef="let acutation">
                        <span *ngIf="selectionService.selectionPermissions.HasMarcaView">
                            <span matTooltip="Marca de Empresa"
                                *ngIf="acutation.marcas !== null && acutation.marcas.includes('E')"
                                class="lbl3">E</span>
                            <span matTooltip="Marca de Médico"
                                *ngIf="acutation.marcas !== null && acutation.marcas.includes('M')"
                                class="lbl4">M</span>
                            <span matTooltip="Marca de Coordinador"
                                *ngIf="acutation.marcas !== null && acutation.marcas.includes('C')"
                                class="lbl2">C</span>
                            <span matTooltip="Marca de Mutua"
                                *ngIf="acutation.marcas !== null && acutation.marcas.includes('U')"
                                class="lbl8">U</span>
                            <span matTooltip="Marca de Diagnóstico"
                                *ngIf="acutation.marcas !== null && acutation.marcas.includes('D')"
                                class="lbl7">D</span>
                            <span matTooltip="Marca de Zona"
                                *ngIf="acutation.marcas !== null && acutation.marcas.includes('Z')"
                                class="lbl7">Z</span>
                                <span matTooltip="Marca de Simulación" *ngIf="acutation.marcas !== null && acutation.marcas.includes('S')"
                            class="lbl7">S</span>
                            <span matTooltip="Marca de Salud Mental" *ngIf="acutation.marcas !== null && acutation.marcas.includes('L')"
                            class="lbl7">L</span>
                                
                        </span>
                        <span *ngIf="selectionService.selectionPermissions.HasMarcaExternalView">
                            <span matTooltip="Marca externa"
                                *ngIf="acutation.marcas !== null && acutation.marcas.includes('X')"
                                class="lbl7">X</span>
                        </span>
                        <span *ngIf="selectionService.selectionPermissions.HasAbsentista">
                            <span matTooltip="Absentista" *ngIf="acutation.absentista === 'S'" class="lbl9">
                                <span class="fa fa-hand-stop-o icon-red"></span>    
                            </span>
                        </span>
                        <span >
                            <span matTooltip="Prioritaria" *ngIf="acutation.prioritaria === 'S'" class="lbl9">
                                <span class="fa fa-star icon-red"></span>
                            </span>
                        </span>
                        <span >
                            <span matTooltip="Inspección" *ngIf="acutation.ifPresentacion !== null" class="lbl6">INSP</span>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="grabacion">
                    <th id="grabacion" mat-header-cell *matHeaderCellDef> Grab. </th>
                    <td mat-cell *matCellDef="let acutation">

                        <template *ngIf="acutation.grabacion === null">
                            <span
                                *ngIf="acutation.citacionGrabada === 'S' || acutation.ConsentimientoGrabado === 'S'"><span
                                    class="fa fa-circle icon-red"></span></span>
                        </template>
                        <template *ngIf="acutation.grabacion !== null">
                            <span
                                *ngIf="acutation.citacionGrabada === 'S' || acutation.ConsentimientoGrabado === 'S'"><span
                                    class="fa fa-circle icon-yellow"></span></span>
                            <span *ngElse><span class="fa fa-circle icon-orange"></span></span>
                        </template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="documento">
                    <th id="documento" mat-header-cell *matHeaderCellDef> Doc. </th>
                    <td mat-cell *matCellDef="let acutation">
                        <mat-icon *ngIf="acutation.documento > 0"
                            class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                            check </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="empresa">
                    <th id="empresa" mat-header-cell *matHeaderCellDef> Empresa </th>
                    <td mat-cell *matCellDef="let acutation">
                        <div class="overflow-text">{{acutation.empresa | titlecase}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="proyecto">
                    <th id="proyecto" mat-header-cell *matHeaderCellDef> Proyecto </th>
                    <td mat-cell *matCellDef="let acutation">
                        <div class="overflow-text">{{acutation.proyecto | titlecase}}</div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="PdteContestar">
                    <th id="PdteContestar" mat-header-cell *matHeaderCellDef> Pdte. Contestar </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.pdteContestar}} </td>
                </ng-container>

                <ng-container matColumnDef="Aprobada">
                    <th id="Aprobada" mat-header-cell *matHeaderCellDef> Aprobada </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.aprobada}} </td>
                </ng-container>

                <ng-container matColumnDef="Rechazada">
                    <th id="Rechazada" mat-header-cell *matHeaderCellDef> Rechazada </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.rechazada}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel1">
                    <th id="nivel1" mat-header-cell *matHeaderCellDef> Nivel 1 </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.nivel1}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel2">
                    <th id="nivel2" mat-header-cell *matHeaderCellDef> Nivel 2 </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.nivel2}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel3">
                    <th id="nivel3" mat-header-cell *matHeaderCellDef> Nivel 3 </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.nivel3}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel4">
                    <th id="nivel4" mat-header-cell *matHeaderCellDef> Nivel 4 </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.nivel4}} </td>
                </ng-container>

                <ng-container matColumnDef="nivel5">
                    <th id="nivel5" mat-header-cell *matHeaderCellDef> Nivel 5 </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.nivel5}} </td>
                </ng-container>

                <ng-container matColumnDef="referencia">
                    <th id="referencia" mat-header-cell *matHeaderCellDef> Referencia </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.referencia | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="leaveRef">
                    <th id="leaveRef" mat-header-cell *matHeaderCellDef> Referencia de Baja </th>
                    <td mat-cell *matCellDef="let leave"> {{leave.leaveRef}} </td>
                </ng-container>


                <ng-container matColumnDef="nif">
                    <th id="nif" mat-header-cell *matHeaderCellDef> NIF </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.nif | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="trabajador">
                    <th id="trabajador" mat-header-cell *matHeaderCellDef> Trabajador </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.trabajador | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="provincia">
                    <th id="provincia" mat-header-cell *matHeaderCellDef> Provincia </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.provincia | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="poblacion">
                    <th id="poblacion" mat-header-cell *matHeaderCellDef> Población </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.poblacion | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="cp">
                    <th id="cp" mat-header-cell *matHeaderCellDef> C.P. </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.cp | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="prioritaria">
                    <th id="prioritaria" mat-header-cell *matHeaderCellDef> Prior. </th>
                    <td mat-cell *matCellDef="let acutation">
                        <span *ngIf="acutation.prioritaria === 'S'">
                            <mat-icon><span class="fa fa-star icon-yellow"></span></mat-icon>
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="tipo">
                    <th id="tipo" mat-header-cell *matHeaderCellDef> Tipo </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.tipo}} </td>
                </ng-container>


                <ng-container matColumnDef="fBaja">
                    <th id="fBaja" mat-header-cell *matHeaderCellDef> F. Baja </th>
                    <td mat-cell *matCellDef="let acutation"> {{ acutation.fBaja | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="fAlta">
                    <th id="fAlta" mat-header-cell *matHeaderCellDef> F. Alta </th>
                    <td mat-cell *matCellDef="let acutation"> {{ acutation.fAlta | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="medico">
                    <th id="medico" mat-header-cell *matHeaderCellDef> Medico </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.medico}} </td>
                </ng-container>

                <ng-container matColumnDef="nj">
                    <th id="nj" mat-header-cell *matHeaderCellDef> NJ </th>
                    <td mat-cell *matCellDef="let acutation">
                        <span *ngIf="acutation.justificada === 'N'" class="lbl1">{{acutation.nj}}</span>
                        <span *ngIf="acutation.justificada === 'A'" class="lbl8">{{acutation.nj}}</span>

                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaNJ">
                    <th id="fechaNJ" mat-header-cell *matHeaderCellDef> Fecha NJ </th>
                    <td mat-cell *matCellDef="let acutation"> {{ acutation.fechaNJ | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="diasNJ">
                    <th id="diasNJ" mat-header-cell *matHeaderCellDef> Dias NJ </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.diasNJ}} </td>
                </ng-container>

                <ng-container matColumnDef="fpa">
                    <th id="fpa" mat-header-cell *matHeaderCellDef> FPA </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fpa | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="diagnostico">
                    <th id="diagnostico" mat-header-cell *matHeaderCellDef> Diagnóstico </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.diagnostico}} </td>
                </ng-container>

                <ng-container matColumnDef="grupoD">
                    <th id="grupoD" mat-header-cell *matHeaderCellDef> Grupo D. </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.grupoD}} </td>
                </ng-container>

                <ng-container matColumnDef="atributos">
                    <th id="atributos" mat-header-cell *matHeaderCellDef> Atributos </th>
                    <td mat-cell *matCellDef="let acutation">
                        <span *ngIf="acutation.tAttr1  ">
                            {{acutation.tAttr1 | titlecase}} ||
                        </span>
                        <span *ngIf="acutation.tAttr2  ">
                            {{acutation.tAttr2 | titlecase}} ||
                        </span>
                        <span *ngIf="acutation.tAttr3  ">
                            {{acutation.tAttr3 | titlecase}} ||
                        </span>
                        <span *ngIf="acutation.tAttr4  ">
                            {{acutation.tAttr4 | titlecase}} ||
                        </span>
                        <span *ngIf="acutation.tAttr5  ">
                            {{acutation.tAttr5 | titlecase}} ||
                        </span>
                        <span *ngIf="acutation.tAttr6  ">
                            {{acutation.tAttr6 | titlecase}} ||
                        </span>
                        <span *ngIf="acutation.tAttr7  ">
                            {{acutation.tAttr7 | titlecase}} ||
                        </span>
                        <span *ngIf="acutation.tAttr8  ">
                            {{acutation.tAttr8 | titlecase}} || 
                        </span>
                        <span *ngIf="acutation.tAttr9  ">
                            {{acutation.tAttr9 | titlecase}} 
                        </span>
                        <span *ngIf="acutation.tAttr10 ">
                            {{acutation.tAttr10 | titlecase}} 
                        </span>
                        <span *ngIf="acutation.tAttr11 ">
                            {{acutation.tAttr11 | titlecase}} 
                        </span>
                        <span *ngIf="acutation.tAttr12 ">
                            {{acutation.tAttr12 | titlecase}} 
                        </span>
                        <span *ngIf="acutation.tAttr1 && acutation.tAttr2  && acutation.tAttr3  &&acutation.tAttr4  &&acutation.tAttr5  &&
                            acutation.tAttr6  && acutation.tAttr7  && acutation.tAttr8  && acutation.tAttr9  && acutation.tAttr10  &&
                            acutation.tAttr11  && acutation.tAttr12 ">
                            Sin Atributos
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="tAttr1">
                    <th id="tAttr1" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[0].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr1 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr2">
                    <th id="tAttr2" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[1].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr2 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr3">
                    <th id="tAttr3" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[2].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr3 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr4">
                    <th id="tAttr4" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[3].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr4 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr5">
                    <th id="tAttr5" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[4].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr5 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr6">
                    <th id="tAttr6" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[5].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr6 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr7">
                    <th id="tAttr7" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[6].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr7 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr8">
                    <th id="tAttr8" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[7].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr8 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr9">
                    <th id="tAttr9" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[8].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr9 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr10">
                    <th id="tAttr10" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[9].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr10 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr11">
                    <th id="tAttr11" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[10].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr11 | titlecase}} </td>
                </ng-container>
                <ng-container matColumnDef="tAttr12">
                    <th id="tAttr12" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[11].attributoName}} </th>
                    <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr12 | titlecase}} </td>
                </ng-container>

                <ng-container matColumnDef="fecha">
                    <th id="fecha" mat-header-cell *matHeaderCellDef> Fecha </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fecha | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="hora">
                    <th id="hora" mat-header-cell *matHeaderCellDef> Hora </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.hora | date:"HH:mm"}} </td>
                </ng-container>

                <ng-container matColumnDef="actuacion">
                    <th id="actuacion" mat-header-cell *matHeaderCellDef> Actuacion </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.actuacion}} </td>
                </ng-container>

                <ng-container matColumnDef="smsEstado">
                    <th id="smsEstado" mat-header-cell *matHeaderCellDef>Estado de SMS</th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.smsEstado}}
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="autor">
                    <th id="autor" mat-header-cell *matHeaderCellDef> Autor </th>
                    <td mat-cell *matCellDef="let actuation" 
                        [matTooltip]="getAutorTooltip(actuation)" 
                        matTooltipPosition="below">
                        {{ actuation.autor }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="importeMedico">
                    <th id="importeMedico" mat-header-cell *matHeaderCellDef> Importe Médico </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.importeMedico | currency:'EUR':true}} </td>
                </ng-container>

                <ng-container matColumnDef="texto">
                    <th id="texto" mat-header-cell *matHeaderCellDef> Texto </th>

                    <td mat-cell *matCellDef="let acutation">
                        {{acutation.texto}}
                    </td>

                </ng-container>

                <ng-container matColumnDef="fRevision">
                    <th id="fRevision" mat-header-cell *matHeaderCellDef> F. Revisión </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fRevision | date:"dd/MM/yyyy"}} </td>
                </ng-container>

                <ng-container matColumnDef="coordinador">
                    <th id="coordinador" mat-header-cell *matHeaderCellDef> Coordinador </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.coordinador}} </td>
                </ng-container>

                <ng-container matColumnDef="comRev">
                    <th id="comRev" mat-header-cell *matHeaderCellDef> Com. Rev. </th>
                    <td mat-cell *matCellDef="let acutation">
                        <mat-icon *ngIf="acutation.comRev !== null"
                            class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                            check </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ordenRev">
                    <th id="ordenRev" mat-header-cell *matHeaderCellDef> Orden Rev. </th>
                    <td mat-cell *matCellDef="let acutation">
                        <mat-icon *ngIf="acutation.ordenRev !== null"
                            class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                            check </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fCitacion">
                    <th id="fCitacion" mat-header-cell *matHeaderCellDef> F. Citación </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fCitacion | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="docCitacion">
                    <th id="docCitacion" mat-header-cell *matHeaderCellDef> Doc. Citación </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.docCitacion | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="respSol">
                    <th id="respSol" mat-header-cell *matHeaderCellDef> Resp. Sol </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.respSol}} </td>
                </ng-container>

                <ng-container matColumnDef="fRespSol">
                    <th id="fRespSol" mat-header-cell *matHeaderCellDef> F. Resp. Sol </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fRespSol | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="fProgrSol">
                    <th id="fProgrSol" mat-header-cell *matHeaderCellDef> F. Progr. Sol </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fProgrSol | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="fRealSol">
                    <th id="fRealSol" mat-header-cell *matHeaderCellDef> F. Real. Sol </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fRealSol | date:"dd/MM/yyyy" }} </td>
                </ng-container>

                <ng-container matColumnDef="fRegistro">
                    <th id="fRegistro" mat-header-cell *matHeaderCellDef> F. Registro </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.fRegistro | date:"dd/MM/yyyy HH:mm" }} </td>
                </ng-container>

                <ng-container matColumnDef="usuario">
                    <th id="usuario" mat-header-cell *matHeaderCellDef> Usuario </th>
                    <td mat-cell *matCellDef="let acutation"> {{acutation.usuario}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
                <tr mat-row *matRowDef="let acutation; columns: getDisplayedColumns();" [ngClass]="{'selection-highlight-row': selectedRowIndex == acutation.actuacionId && selectionService.isShowLeavePanel, 
                    'row-matching': recordingService.isMatching, 'row-matched': acutation.isMatching}"
                    (click)="getLeaveRecord(acutation, $event)">
                </tr>
            </table>
        </div>
    </div>
</div>